import styled from 'styled-components'

export const GridData = styled.ul`
  margin-top: 3rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  row-gap: 2rem;
  font-size: 12px;
  list-style: none;
  padding: 0;
`

export const Label = styled.label`
  font-weight: 700;

  .english{
    color:#0090D3;
    font-style: italic;
    font-weight: 400;
  }
`

export const ShowData = styled.span`

`